import React, { Component } from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import localize from '../localize';
import Modal, { ModalHeader, ModalBody } from '../Modal';
import FindLocation from '../FindLocation';
import PageHeader from '../PageHeader';
import Location from '../Location';
import Select from '../Select';
import { withRouter } from 'react-router-dom';
import { openFeedback, closeFeedback, setFeedbackStep, setFeedbackLocation,
				 setFeedbackIsp, setFeedbackIspOther, fetchFeedbackLocation,
				 clearFeedbackLocation, setFeedbackShard, setFeedbackData } from '../../actions/feedback';
import statsTracker from '../../utils/stats_tracker';
import './Feedback.css';

export const FeedbackStartBare = ({ i18n, nextStep, submitting, setFeedbackData }) => (
	<div className="feedback-start text-center">
		<ModalHeader>
			<PageHeader i18nPath={i18n.path()} />
		</ModalHeader>
		<ModalBody>
			<div className="content">{ i18n.t('content') }</div>
			<div className="form-actions">
				<q-button disabled={submitting} onClick={() => {
					setFeedbackData({ feedback_start: true });
					nextStep('location-confirm');
				}}>{ i18n.t('start') }</q-button>
			</div>
			<div className="disclaimer">
				{ i18n.t('disclaimer') }
			</div>
		</ModalBody>
	</div>
);

export const FeedbackStart = localize('feedback.start')(FeedbackStartBare);

export const LocationConfirmBare = ({ i18n, nextStep, location, setFeedbackData, submitting }) => (
	<div className="location-confirm text-center">
		<ModalHeader>
			<PageHeader i18nPath={i18n.path()} />
		</ModalHeader>

		<ModalBody>
			<div className="question">
				{ i18n.t('question') }
			</div>

			<div className="confirm">
				<Location location={location} />
			</div>

			<div className="form-actions">
				<q-button disabled={submitting} onClick={() => {
					setFeedbackData({ location_correct: true });
					nextStep('isp-confirm');
				}}>{ i18n.t('yes') }</q-button>

				<q-button disabled={submitting} onClick={() => {
					setFeedbackData({ location_correct: false });
					nextStep('change-location');
				}}>{ i18n.t('no') }</q-button>
			</div>
		</ModalBody>
	</div>
);

const LocationConfirm = localize('feedback.location_confirm')(LocationConfirmBare);

export const IspConfirmBare = ({ i18n, nextStep, isp, hasIsps, setFeedbackData, clearFeedbackIsp, submitting }) => (
	<div className="isp-confirm text-center">
		<ModalHeader>
			<PageHeader i18nPath={i18n.path()} />
		</ModalHeader>

		<ModalBody>
			<div className="question">
				{ i18n.t('question') }
			</div>

			<div className="confirm">
				{ isp.name }
			</div>

			<div className="form-actions">
				<q-button disabled={submitting} onClick={() => {
					setFeedbackData({ isp_correct: true });
					nextStep('thank-you');
				}}>{ i18n.t('yes') }</q-button>
				<q-button disabled={submitting} onClick={() => {
					setFeedbackData({ isp_correct: false });
					nextStep(hasIsps ? 'change-isp' : 'other-isp').then(() => {
						clearFeedbackIsp();
					});
				}}>{ i18n.t('no') }</q-button>
			</div>
		</ModalBody>
	</div>
);

const IspConfirm = compose(
	localize('feedback.isp_confirm'),
	connect(state => {
		return {
			hasIsps: state.feedback.location && state.feedback.location.isps.length > 0
		};
	}, dispatch => {
		return {
			clearFeedbackIsp: () => dispatch(setFeedbackIsp(null))
		};
	})
)(IspConfirmBare);

export const ThankYouBare = ({ i18n, nextStep }) => (
	<div className="thank-you text-center">
		<ModalHeader>
			<PageHeader i18nPath={i18n.path()} />
		</ModalHeader>

		<ModalBody>
			<div className="text-center">
				<img src={require('./riot-logo.png')} alt={i18n.t('header')} />
			</div>

			<div className="form-actions">
				<q-button onClick={() => nextStep('close')}>{ i18n.t('close') }</q-button>
			</div>
		</ModalBody>
	</div>
);

const ThankYou = localize('feedback.thank_you')(ThankYouBare);

const ChangeLocationBare = ({ i18n, location, shard, nextStep, handleLocationSelected, handleLocationNotFound, setFeedbackData }) => (
	<div className='change-location'>
		<FindLocation shard={shard}
			country={location.country_code}
			searchHeader={ <PageHeader i18nPath={i18n.path('search')} /> }
			locationHeader={<div><PageHeader i18nPath={i18n.path('location')} /><div className="question">{ i18n.t('location.content') }</div></div>}
			searchButtonText={ i18n.t('search.select_location') }
			locationButtonText={ i18n.t('location.go') }
			onLocationSelected={async (values) => {
				await handleLocationSelected(values);
				setFeedbackData({ location_id: values.location_id });
				nextStep('isp-confirm');
			}}
			onLocationNotFound={(values) => {
				setFeedbackData({ location_searched: values.location_searched, location_not_found: true });
				handleLocationNotFound(values);
				nextStep('location-not-found');
			}} />
		</div>
);

const ChangeLocation = compose(localize('feedback.change_location'), connect(state => {
	return {
		location: state.player.location.location,
		shard: state.config.shard
	}
}, (dispatch, ownProps) => {
	return {
		handleLocationNotFound: ({ shard }) => {
			dispatch(setFeedbackShard(shard));
			dispatch(clearFeedbackLocation());
		},
 		handleLocationSelected: ({ location_id, shard }) =>  {
 			dispatch(setFeedbackShard(shard));
 			return dispatch(fetchFeedbackLocation(location_id, shard));
 		}
	}
}))(ChangeLocationBare);

export const ChangeIspBare = ({ i18n, isps, isp, nextStep, handleIspChange, location, setFeedbackData, submitting }) => {
	const options = isps.map(isp => ({label: isp.name, value: isp.id }));

	options.sort((a, b) => a.label > b.label ? 1 : -1);

	return <div className='change-isp'>
						<ModalHeader>
							<PageHeader i18nPath={i18n.path()} />
						</ModalHeader>
						<ModalBody>
							<div className="field-narrow text-left">
			          <label>{ i18n.t('available_isps') }: { location.city } </label>
			          <Select options={options} onChange={(value) => handleIspChange(value)} value={isp && isp.id} clearable={false} />

			          <div className="text-center form-actions">
			            <q-button disabled={submitting || !!!isp} onClick={() => {
			            	setFeedbackData({ isp_id: isp.id });
			            	nextStep('thank-you');
			            }}>{ i18n.t('select_isp') }</q-button>
			          </div>
			          <div className="text-center not-listed">
			          	<a onClick={() => {
			          		setFeedbackData({ isp_not_found: true });
			          		nextStep('other-isp');
			          	}}>{ i18n.t('not_listed') }</a>
			          </div>
			        </div>
						</ModalBody>
		      </div>;
};

const ChangeIsp = compose(localize('feedback.change_isp'), connect(state => {
		return {
			isp: state.feedback.isp,
			location: state.feedback.location.location
		};
	}, (dispatch, ownProps) => {
		return {
			handleIspChange: ({ value }) => dispatch(setFeedbackIsp(ownProps.isps.find(isp => isp.id === value)))
		}
}))(ChangeIspBare);

export const LocationNotFoundBare = ({ i18n, nextStep, submitting }) => (
	<div className='location-not-found'>
		<ModalHeader>
			<PageHeader i18nPath={i18n.path()} />
		</ModalHeader>

		<ModalBody>
			<div className="content">
				{ i18n.t('content') }
			</div>

			<div className="form-actions">
				<q-button disabled={submitting} onClick={() => nextStep('isp-confirm')}>{ i18n.t('next') }</q-button>
			</div>
		</ModalBody>
	</div>
);

const LocationNotFound = localize('feedback.location_not_found')(LocationNotFoundBare);

export const IspNotListedBare = ({ i18n, handleIspChange, nextStep, isp_other, setFeedbackData, submitting }) => (
	<div className="isp-not-listed">
		<ModalHeader>
			<PageHeader i18nPath={i18n.path()} />
		</ModalHeader>

		<ModalBody>
			<div className="content" dangerouslySetInnerHTML={{ __html: i18n.t('content') }} />

			<div>
				<input type="text" onChange={(e) => handleIspChange(e.target.value)} placeholder={i18n.t('who_isp')} value={isp_other} />
			</div>

			<div className="form-actions">
				<q-button onClick={() => {
					setFeedbackData({ isp_other });
					nextStep('thank-you');
				}} disabled={isp_other.length === 0 || submitting}>{ i18n.t('next') }</q-button>
			</div>
		</ModalBody>
	</div>
);

const IspNotListed = compose(localize('feedback.isp_not_listed'), connect(state => {
	return {
		isp_other: state.feedback.isp_other
	}
}, dispatch => {
	return {
		handleIspChange: (name) => dispatch(setFeedbackIspOther(name))
	}
}))(IspNotListedBare);

export class FeedbackBare extends Component {
	componentWillMount() {
		this.defaultLocations();
	}

	componentDidUpdate() {
		///this.defaultLocations();
	}

	defaultLocations() {
		const { feedbackLocation, detectedLocation, feedbackIsp, detectedIsp, feedbackShard, detectedShard } = this.props;

		if(!feedbackLocation) {
			this.props.setFeedbackLocation({ ...detectedLocation, isps: detectedLocation.unfilteredIsps });
		}
		if(!feedbackIsp) {
			this.props.setFeedbackIsp(detectedIsp);
		}
		if(!feedbackShard) {
			this.props.setFeedbackShard(detectedShard);
		}
	}

	closeAndRedirect() {
		const { feedbackShard, feedbackLocation, detectedLocation, history, closeFeedback } = this.props;

		closeFeedback();

		if(feedbackLocation.location === null) {
			history.push(`/results/${feedbackShard}/`);
		} else if(feedbackLocation.location.id !== detectedLocation.location.id) {
			history.push(`/results/${feedbackShard}/${feedbackLocation.location.id}`)
		}
	}

	renderSteps() {
		const { submitting, setFeedbackStep, setFeedbackData, feedbackIsp, step, feedbackLocation } = this.props;

		const nextStep = (step) => setFeedbackStep(step);
		const stepProps = { nextStep, setFeedbackData, submitting };

		return (<div className={step}>
							{ step === 'start' && <FeedbackStart {...stepProps} /> }
							{ step === 'location-confirm' && <LocationConfirm location={feedbackLocation.location} {...stepProps} /> }
							{ step === 'change-location' && <ChangeLocation {...stepProps}  /> }
							{ step === 'location-not-found' && <LocationNotFound {...stepProps}  /> }
							{ step === 'isp-confirm' && <IspConfirm isp={feedbackIsp} {...stepProps}/> }
							{ step === 'change-isp' && <ChangeIsp isps={feedbackLocation.isps} {...stepProps} /> }
							{ step === 'other-isp' && <IspNotListed {...stepProps} /> }
							{ step === 'thank-you' && <ThankYou nextStep={() => this.closeAndRedirect()} /> }
						</div>);
	}

	render() {
		const { isOpen, openFeedback, closeFeedback } = this.props;

		return (<div className="feedback-container">
							<div onClick={(e) => {
								statsTracker.trackEvent('click', 'feedback');
								openFeedback();
								e.stopPropagation();
							}}>{this.props.children}</div>
							<Modal contentLabel="Feedback" isOpen={isOpen} handleModalClose={() => closeFeedback()}>
								{this.renderSteps()}
							</Modal>
						</div>);
	}
}

export default compose(localize('feedback'), withRouter, connect(state => {
	return {
		isOpen: state.feedback.isOpen,
		step: state.feedback.step,
		submitting: state.feedback.submitting,
		detectedLocation: state.player.location,
		feedbackLocation: state.feedback.location,
		feedbackShard: state.feedback.shard,
		detectedIsp: state.player.isp,
		feedbackIsp: state.feedback.isp,
		detectedShard: state.config.shard
	}
}, dispatch => {
	return {
		openFeedback: () => dispatch(openFeedback()),
		closeFeedback: () => dispatch(closeFeedback()),
		setFeedbackStep: (step) => dispatch(setFeedbackStep(step)),
		setFeedbackLocation: (location) => dispatch(setFeedbackLocation(location)),
		setFeedbackIsp: (isp) => dispatch(setFeedbackIsp(isp)),
		setFeedbackShard: (shard) => dispatch(setFeedbackShard(shard)),
		setFeedbackData: (data) => dispatch(setFeedbackData(data))
	};
}))(FeedbackBare);



// WEBPACK FOOTER //
// ./src/components/Feedback/index.js